// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  id: __t.string(),
  name: __t.option(__t.string()),
  logo: __t.option(__t.string()),
  customerId: __t.option(__t.string()),
  ownerId: __t.option(__t.string()),
  glaciContextCatalog: __t.option(__t.string()),
  glaciFeatures: __t.option(__t.string()),
  glaciInstances: __t.option(__t.string()),
  glaciBranding: __t.option(__t.string()),
  runtimeUri: __t.option(__t.string()),
  runtimeModule: __t.option(__t.string()),
};
